import { InvoiceLine } from '@apply/api/src/api/PaymentApi';
import { useAuthentication } from '../../../Login/hooks/useAuthentication';
import { useCallback } from 'react';

export const useCalculateAppraisalInvoiceTotal = () => {
    const { authentication } = useAuthentication();

    const calculateAppraisalInvoiceTotal = useCallback(
        (appraisalInvoice: InvoiceLine[]): number | undefined => {
            if (!authentication) return undefined;
            if (!authentication?.user) return undefined;

            const { requireUnderwritingFee, requireValuationFee } = authentication.user;

            const total = appraisalInvoice
                ? appraisalInvoice.reduce((cost, listing) => {
                      if (requireUnderwritingFee) cost += listing.underwritingFee;
                      if (requireValuationFee) cost += listing.cost;

                      return cost;
                  }, 0)
                : 0;

            return total;
        },
        [authentication?.user?.requireUnderwritingFee, authentication?.user?.requireValuationFee]
    );

    return { calculateAppraisalInvoiceTotal };
};
